import moment from 'moment';

/**
 * Get data type for given value
 * @param value
 * @returns {*}
 */
export const getDataType = (value) => {
  if (moment.isMoment(value)) return 'moment';
  return value instanceof Date
    ? 'date'
    : typeof value;
};

/**
 * Returns value to be used for scheduling as inputs can be Date/String/Number
 * @param value
 * @returns {undefined|Date|*}
 */
export const getSchedulingValue = (value) => {
  const type = getDataType(value);
  switch (type) {
    case 'string':
    case 'date':
      return moment(value);
    case 'number':
    case 'moment':
      return value;
    default:
      return undefined;
  }
};

/**
 * Returns number of days in a month given month number
 * @param month
 * @returns {number}
 */
export const getDaysPerMonth = (month) => (
  month === 2
    ? 29 // Since we don't know the year just assume a leap year
    : new Date(2019, month, 0).getDate() // Other months will always be the same every year
);

/**
 * Generate list of hour exmaples based on hour interval given
 * @param interval
 * @param numberOfExamples
 * @returns {[], boolean}
 */
export const getHourExamplesForDay = (interval, numberOfExamples = 4) => {
  if (interval > 0 && interval < 24) {
    const examples = [];
    let currentTime = moment('00:00', 'HH:mm');
    for (let i = 0; i < numberOfExamples; i += 1) {
      examples.push(currentTime.clone());
      currentTime = currentTime.add(interval, 'hours');
    }
    return examples;
  }
  return false;
};

/**
 * Generate list of minute examples based on minute interval given
 * @param interval of minutes
 * @param numberOfExamples
 * @returns {[], boolean}
 */
export const getMinutesExamplesForDay = (interval, numberOfExamples = 4) => {
  if (interval > 0 && interval < 60) {
    const examples = [];
    let currentTime = moment('00:00', 'HH:mm');
    for (let i = 0; i < numberOfExamples; i += 1) {
      examples.push(currentTime.clone());
      currentTime = currentTime.add(interval, 'minutes');
    }
    return examples;
  }
  return false;
};
